import useNavModel, { RouterParamType } from '@/model/navModel'
import { Checkbox, Select, Table } from 'antd'
import React, { useEffect, useState } from 'react'
import { vehicleDetialModel } from './vehicleDetailModel'
import YhTootip from '@/components/YhTootip'
import { changeTime } from '@/utils/utils'
import useGlobalModel from '@/model/globalModel'
import ImgModal from './imgModal'
// eslint-disable-next-line react-hooks/rules-of-hooks
export const ThreeInspectionLedgerDetails = () => {
    const { getSelectedNavState } = useNavModel(({ selectedNavId }) => [selectedNavId])
    const [detailsInfo] = useState<RouterParamType>(getSelectedNavState() as RouterParamType)
    const { dictHeaderData } = useGlobalModel(({ user }) => [user])
    const { initPgCfg, getOne, detailLookList, detialSearchValues, setDetialSearchValues, setImgVisible } = vehicleDetialModel()
    const [newData, setNewData] = useState<any>([])
    const [imgLookData, setImgLookData] = useState<any>([])
    useEffect(() => {
        setDetialSearchValues({ pcode: '', status: false })
        getOne(initPgCfg, detailsInfo.id).then((res) => {})
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [detailsInfo])

    useEffect(() => {
        setNewData(detailLookList)
    }, [detailLookList])
    const lookPic = (list: any) => {
        setImgLookData(list)
        setImgVisible(true)
    }
    const findValues = (val: any) => {
        let newList = JSON.parse(JSON.stringify(detailLookList))
        let data: any = []
        newList.forEach((item: any) => {
            let a = val.status ? 'NO' : item.status
            let b = val.pcode ? val.pcode : item.pcode
            let c = val.enableStatus ? 'OPEN' : item.enableStatus
            if (item.status === a && item.pcode === b && item.enableStatus === c) {
                data.push(item)
            }
        })
        setNewData(data)
    }

    const columns: any = [
        {
            title: '序号',
            width: 60,
            fixed: 'left',
            render: (_t: string, _r: any, i: number) => i + 1,
        },
        {
            title: '出车状态',
            width: 120,
            dataIndex: 'statusType',
            align: 'center',
            render: (_text: string, _record: any) => {
                let _detailsInfo = {
                    frontTotalNum: 0,
                    inTotalNum: 0,
                    afterTotalNum: 0,
                }
                let index: number = newData.findIndex((item: any) => item.id === _record.id)
                if (window.localStorage.getItem('ledgerDetails')) {
                    _detailsInfo = JSON.parse(window.localStorage.getItem('ledgerDetails') as string)
                }
                const frontTotalNum = _detailsInfo.frontTotalNum || 0
                const inTotal = _detailsInfo.inTotalNum || 0
                const afterTotal = _detailsInfo.afterTotalNum || 0
                const totalRecords = newData?.length || 0

                // 根据小程序中的逻辑实现
                let statusText = ''
                if (totalRecords <= frontTotalNum) {
                    // 如果总数量小于等于frontTotalNum时，全部为出车前
                    statusText = '出车前'
                } else if (totalRecords > frontTotalNum && totalRecords <= frontTotalNum + inTotal) {
                    // 如果总数量大于frontTotalNum且小于等于frontTotalNum+inTotal时
                    if (index + 1 < frontTotalNum) {
                        statusText = '出车中'
                    } else {
                        statusText = '出车前'
                    }
                } else {
                    // 如果总数量大于frontTotalNum+inTotal时
                    if (index + 1 > afterTotal + inTotal) {
                        statusText = '出车前'
                    } else if (index + 1 > afterTotal && index + 1 <= afterTotal + inTotal) {
                        statusText = '出车中'
                    } else {
                        statusText = '出车后'
                    }
                }

                return statusText
            },
        },
        {
            title: '项目名称',
            width: 160,
            dataIndex: 'itemName',
            align: 'center',
            render: (text: string) => <YhTootip text={text} style={{ width: '360px' }} />,
        },
        {
            title: '创建时间',
            width: 120,
            dataIndex: 'createTime',
            align: 'center',
            render: (text: string) => <span>{changeTime(text)}</span>,
        },
        {
            title: '完成状态',
            width: 120,
            dataIndex: 'status',
            align: 'center',
            render: (text: string) => <span style={{ color: text === 'YES' ? '#000' : '#ec261b' }}>{text === 'YES' ? '通过' : '不通过'}</span>,
        },
        {
            title: '完成人',
            width: 160,
            dataIndex: 'createUser',
            align: 'center',
        },
        {
            title: '图片',
            width: 160,
            dataIndex: 'createUser',
            align: 'center',
            render: (_text: string, record: any) =>
                record.imgList?.length > 0 && (
                    <span
                        style={{ color: 'blue', cursor: 'pointer' }}
                        onClick={() => {
                            lookPic(record.imgList)
                        }}
                    >{`图片(${record.imgList?.length})张`}</span>
                ),
        },
    ]

    return (
        <>
            <div style={{ backgroundColor: '#fff', height: 'calc(100vh - 110px)' }}>
                <div style={{ lineHeight: '50px' }}>
                    <span style={{ margin: '20px', lineHeight: '40px', fontWeight: 'bolder' }}>
                        车牌:<span style={{ color: 'rgba(24,144,255,1)', margin: '10px' }}>{detailsInfo.vehicleNumber}</span>
                    </span>
                    <span style={{ margin: '20px', lineHeight: '40px', fontWeight: 'bolder' }}>
                        {' '}
                        日期:
                        <span
                            style={{
                                color: 'rgba(24,144,255,1)',
                                margin: '10px',
                            }}
                        >
                            {changeTime(detailsInfo.createTime)}
                        </span>
                    </span>
                    <Select
                        style={{ width: '300px', float: 'right', margin: '12px 13px 0 5px' }}
                        allowClear
                        value={detialSearchValues?.pcode}
                        placeholder="出车状态"
                        onChange={(value) => {
                            setDetialSearchValues({ ...detialSearchValues, pcode: value })
                            findValues({ ...detialSearchValues, pcode: value })
                        }}
                        options={[{ label: '全部', value: '' }, ...dictHeaderData]}
                    />
                    {!detialSearchValues.status && (
                        <Checkbox
                            style={{ float: 'right', margin: '3px 10px 0 10px' }}
                            checked={!!detialSearchValues?.enableStatus}
                            onChange={(e) => {
                                setDetialSearchValues({ ...detialSearchValues, enableStatus: e.target.checked })
                                findValues({ ...detialSearchValues, enableStatus: e.target.checked })
                            }}
                        >
                            强制必传项
                        </Checkbox>
                    )}
                    {!detialSearchValues.enableStatus && (
                        <Checkbox
                            style={{ float: 'right', margin: '3px 10px 0 10px' }}
                            checked={!!detialSearchValues?.status}
                            onChange={(e) => {
                                setDetialSearchValues({ ...detialSearchValues, status: e.target.checked })
                                findValues({ ...detialSearchValues, status: e.target.checked })
                            }}
                        >
                            不通过项
                        </Checkbox>
                    )}
                </div>
                <Table
                    rowKey={(record) => record.id}
                    // rowClassName={(record) => {
                    //     debugger
                    //     if (record?.repairAddress=='天津市津南区天津津南开发区旺港路15号津交富港物流公司') return "background-b6b3b3";
                    //     return ""
                    // }}

                    columns={columns}
                    scroll={{ x: 'max-content', y: 'calc(100vh - 255px)' }}
                    dataSource={newData}
                    pagination={{
                        // ...pgCfg,
                        // position: ['bottomRight'],
                        showTotal: () => `共${newData?.length}条`,
                        // // onChange: (pageNum, pageSize) => {
                        // //     getOne({ pageNum, pageSize },detailsInfo.id)
                        // // },
                        defaultPageSize: 50,
                        showSizeChanger: true,
                    }}
                    bordered
                    style={{ margin: '0 10px' }}
                />
                <ImgModal modalData={imgLookData} />
            </div>
        </>
    )
}
